import React, {Fragment} from 'react';
import Overlay from 'Components/Overlay';
import Cx from 'classnames';
import Moment from 'moment';
import { DateRangePicker, SingleDatePicker } from 'react-dates';
import Dropdown from 'Components/Dropdown/index';
import Input from 'Components/Input';
import Checkbox from 'Components/Checkbox/index';
import { ROQUETTE, BEAM } from 'Constants/commonConstants';

const updateDPH = (props)=>(
   
    <Fragment>
        <Overlay>
            <div className="bg-white box-shadow ph-20 pv-20 br-5">
                <div className={Cx("mb-10 tCenter fSemibold", {
                    'error-color fs-16': props.isTextErrorColor,
                    'header-medium-color fs-18': !props.isTextErrorColor
                })}>
                    {`Update ${props.isCargil ? 'PR' : 'DPH'}`}
                </div>
                <div className='bg-white box-shadow'>
                    <div>
                        <div className="fs-16 pv-10 fBold ml-30 header-medium-color">{`${props.isCargil ? 'PR' : 'DPH'} Validity`}</div>
                        <div className={Cx("mb-10 pl-20 pr-20 b-20 wt-300 triangle-bottom br-5", {
                            'ht-400 wt-600': props.focusedInput
                        })}>
                        {ROQUETTE.includes(props.companyId) ? 
                            <SingleDatePicker
                                    noBorder={true}
                                    displayFormat={"DD MMM YYYY"}
                                    hideKeyboardShortcutsPanel={true}
                                    placeholder={"From Date"}
                                    numberOfMonths={2}
                                    date={props.dph.dph_from_date && Moment(props.dph.dph_from_date) || null} 
                                    onDateChange={(e) => props.onChangeDPH('dph_from_date', e)}
                                    focused={props.focusedInput} 
                                    onFocusChange={({ focused }) => props.onFocusChange(focused)}
                            />
                        :
                            <DateRangePicker
                                startDate={props.dph.dph_from_date && Moment(props.dph.dph_from_date) || null}
                                startDateId="startDate"
                                endDate={props.dph.dph_to_date && Moment(props.dph.dph_to_date) || null}
                                endDateId="endDate"
                                onDatesChange={(e) => props.onChangeDPH('date', e)}
                                focusedInput={props.focusedInput}
                                onFocusChange={focusedInput => props.onFocusChange(focusedInput)}
                                displayFormat={'DD MMM YYYY'}
                                noBorder={true}
                                minimumNights={0}
                                isOutsideRange={(date) => BEAM.includes(props.companyId) ? false : date < new Date().setHours(0)}
                            />}
                        </div>
                    </div>
                    {/* {props.showDropdown && 
                    <div className='mb-10'>
                        <div className="fs-16 pl-20 pv-10 fBold header-medium-color">Price Type</div>
                        <div className='pl-20 pr-20'>
                            <Dropdown
                                items={props.revisedPriceDropdown || []}
                                selectedItem={props.revisedPriceType || {}}
                                name="name"
                                onSelect={props.onSelect}
                                displayKey="name"
                                // className="flex-1"
                                label="Select Type"
                            />
                        </div>
                    </div>} */}
                    {
                        props.isCargil &&
                        <>
                            <div className="fs-16 pl-20 pv-10 fBold header-medium-color">PR UOM</div>
                            <div className="flex mb-10 pl-20">
                                <Checkbox label="Percentage" checked={props.dph.dph_uom === 1} className="mr-30" onCheck={() => props.onChangeDPH('uom', 1)} />
                                <Checkbox label="Amount" checked={props.dph.dph_uom === 2} className="mr-30" onCheck={() => props.onChangeDPH('uom', 2)} />
                            </div>
                        </>
                    }
                    <div className='mb-10'>
                        <div className="fs-16 pl-20 pv-10 fBold header-medium-color">{props.isCargil ? `PR ${props.dph.dph_uom == 1 ? 'Percentage' : 'Amount'}` : 'DPH Percentage'}</div>
                        <div className="mb-10 pl-20 pr-20 b-20 wt-300 triangle-bottom br-5">
                            <Input type="number" onChange={(e) => props.onChangeDPH('percentage', e)} value={props.dph.dph_percentage} name="percentage" placeholder="Eg. 1" className="col-1 fs-14"/>
                        </div>
                    </div>
                    {
                        props.isCargil &&
                        <div className='mb-10'>
                            <div className="fs-16 pl-20 pv-10 fBold header-medium-color">{`${props.isCargil ? 'PR' : 'DPH'} Remarks`}</div>
                            <div className="mb-10 pl-20 pr-20 b-20 wt-300 triangle-bottom br-5">
                                <Input onChange={(e) => props.onChangeDPH('remarks', e)} value={props.dph.dph_remarks} name="remarks" placeholder="Eg. remarks" className="col-1 fs-14"/>
                            </div>
                        </div>
                    }
                    <div className="col-1 ht-60 flex flex-middle flex-center bg-white">
                        <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={props.onCancel}>Cancel</button>
                        <button className={Cx("ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30", {
                            'disabled': !(props.dph.dph_percentage && (props.isCargil ? props.dph.dph_uom : true) && props.dph.dph_from_date)
                        })}  onClick={props.onSave}>Save</button>
                    </div>
                </div>
            </div>    
        </Overlay> 
    </Fragment>
);

export default updateDPH;